import React, { lazy, Suspense } from 'react';
import { Route, Switch, useHistory } from 'react-router-dom';
import { connect } from 'react-redux';
import PermissionGuard2 from '../../../../Layout/PermissionGuard2';

// Lazy load components
const NotificationList = lazy(() => import('../Pages/NotificationList'));
const AddNotification = lazy(() => import('../Pages/AddNotification'));
const EditNotification = lazy(() => import('../Pages/EditNotification'));
const NotificationView = lazy(() => import('../Pages/NotificationView'));

// Import loading overlay
import LoadingOverlay from 'react-loading-overlay';
import FadeLoader from 'react-spinners/FadeLoader';
LoadingOverlay.propTypes = undefined;

// Import CSS
import '../Assets/css/notification.scss';

function NotificationRoute() {
  const history = useHistory();
  
  return (
    <Switch>
      <Route
        exact
        path="/:lng/notification"
        render={() => (
          <React.Fragment>
            <Suspense fallback={<Loading />}>
              <NotificationList history={history} />
            </Suspense>
          </React.Fragment>
        )}
      />
      <Route
        exact
        path="/:lng/notification/list"
        render={() => (
          <React.Fragment>
            <Suspense fallback={<Loading />}>
              <NotificationList history={history} />
            </Suspense>
          </React.Fragment>
        )}
      />
      <Route
        exact
        path="/:lng/notification/add"
        render={() => (
          <React.Fragment>
            <Suspense fallback={<Loading />}>
              <AddNotification history={history} />
            </Suspense>
          </React.Fragment>
        )}
      />
      <Route
        exact
        path="/:lng/notification/edit/:slack"
        render={() => (
          <React.Fragment>
            <Suspense fallback={<Loading />}>
              <EditNotification history={history} />
            </Suspense>
          </React.Fragment>
        )}
      />
      <Route
        exact
        path="/:lng/notification/view/:slack"
        render={() => (
          <React.Fragment>
            <Suspense fallback={<Loading />}>
              <NotificationView history={history} />
            </Suspense>
          </React.Fragment>
        )}
      />
    </Switch>
  );
};

export default NotificationRoute;

function Loading() {
  return (
    <>
      <div className="wrapper">
        <span>Loading</span>
      </div>
    </>
  );
}
